import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import type { MacroProps } from "./Macro.d";

const heightMap: Record<string, string> = {
  small: "400px",
  medium: "527px",
  large: "800px",
  full: "100vh",
};

export const MacroPart = (props: ComponentProps<PartData>) => {
  const { src, title, height = "medium" } = (props.data as Partial<MacroProps>) ?? {};

  if (!src) {
    return <p>Legg til en iframe URL.</p>;
  }

  return (
    <div className="container">
      <div className="iframe-wrapper">
        <iframe
          src={src}
          title={title}
          width="100%"
          height={heightMap[height] ?? "527px"}
          style={{ border: "none", display: "block" }}
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default MacroPart;